"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGiftingOnTheFlyTitle = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _giftingOnTheFly = require("../store/giftingOnTheFly.selectors");

var _useGetCampaignId = require("./useGetCampaignId");

var PAGE_TITLE = 'Gifting on the fly';

var useGiftingOnTheFlyTitle = function useGiftingOnTheFlyTitle() {
  var campaignId = (0, _useGetCampaignId.useGetCampaignId)();
  var campaign = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _giftingOnTheFly.getSelectedCampaign)(campaignId);
  }, [campaignId]));
  (0, _react.useEffect)(function () {
    window.document.title = campaign ? "".concat(PAGE_TITLE, " - ").concat(campaign.name) : PAGE_TITLE;
  }, [campaign]);
};

exports.useGiftingOnTheFlyTitle = useGiftingOnTheFlyTitle;